import { targetType } from "core/orderAd/orderAd.entity";
import { makeCall, Methods } from "../../utils/makeCall";
import { CalculatePriceErrors } from "./calculatePrice.error";

export type CalculatePriceRequest = {
  spot: number;
  view_count: number;
  click_count: number;
  link: string;
  is_instant?: boolean;
  target_type?: targetType;
};
export type CalculatePriceResponse = {
  total_price: number;
  final_base_price: number;
  final_price: number;
};

export const calculatePrice = makeCall<
  CalculatePriceRequest,
  CalculatePriceResponse,
  CalculatePriceErrors
>(Methods.CalculatePrice);
